import React from 'react';
import '../template-file-css/document-file-template.css';


export const CBS_UnitedHealthcareAuthForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CBS_UnitedHealthcareAuthForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center>
                        <b>
                            ACT (Assertive Community Treatment) Admission
                            <br />
                            template/requirements (submitted by provider)
                        </b>
                    </center>
                </p>  
                <p className='w-750'>
                    Scenario: Completing a pre-authorization review for the ACT Level of Care (LOC)
                    <br/>
                    Effective Date: 12/01/2015  
                </p>


                <p className='w-750'>
                    Please Email (preferred) OR Fax the completed form to the contact information below:
                    <br/>
                    EMAIL: la.beh.auths@uhc.com
                    &nbsp;
                    FAX #: 1-855-202-7023
                </p>
                <p className='w-750'>
                    <b>NOTE:</b>Requests should be typed and not handwritten. An Assessment and LOCUS (Level of Care
                    Utilization System) must be attached for all authorization requests.
                </p>





                <p className='w-750'>
                    <b> REQUEST: </b>
                </p>
                <table>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Provider name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Tax ID #:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> NPI #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtProviderName' name='txtProviderName' className='add-only' defaultValue={'CBS ACT, LLC'} /> </td>
                        <td className='w-250'> <input type='text' id='txtTax' name='txtTax' className='add-only' defaultValue={'900918793'} /> </td>
                        <td className='w-250'> <input type='text' id='txtNpi' name='txtNpi' className='add-only' defaultValue={'1396081097'} /> </td>
                    </tr>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Date and time of request:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Member name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateRequest' name='txtDateRequest' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='txtTimeRequest' name='txtTimeRequest' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMemberName' name='txtMemberName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Member date of birth:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Member Medicaid identification number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMemberDob' name='txtMemberDob' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMemberMedicaidIdentificationNumber' name='txtMemberMedicaidIdentificationNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Name and phone number of the requestor:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameRequestor' name='txtNameRequestor' className='add-only' defaultValue={'Lori Williams, LPC'} /> </td>
                        <td className='w-375'> <input type='text' id='txtPhoneRequestor' name='txtPhoneRequestor' className='add-only' defaultValue={'318-226-5990'} /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Diagnosis:</span>
                    <span className='small'>(includes Mental Health & Substance Use Disorders, Developmental Delay, personality, medical)</span>
                    <textarea id='txtDiagnosis' name='txtDiagnosis' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Current medication list:</span>
                    <textarea id='txtCurrentMedicationList' name='txtCurrentMedicationList' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> History of psychiatric-related inpatient stays and/or ER visits with dates of service:</span>
                    <textarea id='txtHistoryPsychiatricRelatedInpatient' name='txtHistoryPsychiatricRelatedInpatient' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Current symptoms and how functioning is impacted:</span>
                    <textarea id='txtCurrentSymptoms' name='txtCurrentSymptoms' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Legal issues:</span>
                    <span className='small'>(charges/probation/parole/incarceration) - with description</span>
                    <textarea id='txtLegalIssues' name='txtLegalIssues' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> History of outpatient services:</span>
                    <span className='small'>(include… why is lower LOC not appropriate?)</span>
                    <textarea id='txtHistoryOfOutpatientServices' name='txtHistoryOfOutpatientServices' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Living environment/residence:</span>
                    <textarea id='txtLivingEnvironmentResidence' name='txtLivingEnvironmentResidence' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Risk factors:</span>
                    <span className='small'>(include history of violence, HI/SI, psychosis)</span>
                    <textarea id='txtRiskFactors' name='txtRiskFactors' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Identified support systems:</span>
                    <textarea id='txtIdentifiedSupportSystems' name='txtIdentifiedSupportSystems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Current Primary Care Physician:</span>
                    <span className='small'>(list date of last visit)</span>
                    <textarea id='txtCurrentPrimaryCarePhysician' name='txtCurrentPrimaryCarePhysician' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Treatment goals:</span>
                    <span className='small'>(behaviorally measurable) (include expected outcomes and timeframes)</span>
                    <textarea id='txtTreatmentGoals' name='txtTreatmentGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Discharge plan:</span>
                    <textarea placeholder='Transition to a lower level of care' id='txtDischargePlan' name='txtDischargePlan' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <b> For additional days requested: </b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Identify specific Plan of Care (POC):</span>
                    <span className='small'>(list goals met and remaining, include… why continue at this LOC?)</span>
                    <textarea id='txtIdentifySpecificPlanCare' name='txtIdentifySpecificPlanCare' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Support system development/involvement:</span>
                    <textarea id='txtSupportSystemDevelopmentInvolvement' name='txtSupportSystemDevelopmentInvolvement' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Mental Status Exam/behavior/participation:</span>
                    <textarea id='txtMentalStatusExamBehaviorParticipation' name='txtMentalStatusExamBehaviorParticipation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Medication changes/compliance:</span>
                    <textarea id='txtMedicationChangesCompliance' name='txtMedicationChangesCompliance' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Change in diagnosis:</span>
                    <textarea id='txtChangeInDiagnosis' name='txtChangeInDiagnosis' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Specific discharge plan:</span>
                    <textarea id='txtSpecificDischargePlan' name='txtSpecificDischargePlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Anticipated Length of Stay (LOS):</span>
                    <textarea id='txtAnticipatedLengthOfStay' name='txtAnticipatedLengthOfStay' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Coordination of care activity:</span>
                    <textarea id='txtCoordinationOfCareActivity' name='txtCoordinationOfCareActivity' className='add-only'></textarea>
                </p>



            </div>
        </form>

    )
}











